import Hero from "@/pages/home/components/Hero";
import StatsBand from "@/pages/home/components/StatsBand";
import FeaturedStories from "@/pages/home/components/FeaturedStories";
import HarmGrid from "@/pages/home/components/HarmGrid";
import RecoveryPath from "@/pages/home/components/RecoveryPath";
import FaqSection from "@/pages/home/components/FaqSection";
import AboutPreview from "@/pages/home/components/AboutPreview";
import HelpCta from "@/pages/home/components/HelpCta";
import { site } from "@/mocks/site";

export default function Home() {
  const webSiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: site.name,
    alternateName: site.fullName,
    description: site.intro,
    inLanguage: "zh-CN",
    publisher: {
      "@type": "Organization",
      name: site.name,
      email: site.email,
    },
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: site.name,
    description: site.intro,
    email: site.email,
    foundingDate: String(site.foundedYear),
    knowsAbout: ["网络暴力", "人肉搜索", "网络暴力受害者心理", "网络暴力维权"],
  };

  return (
    <>
      <title>回声墙｜网暴黑料亲历者档案 · 受害者亲述与心理伤害记录</title>
      <meta
        name="description"
        content="回声墙聚焦网暴黑料受害者的真实处境，通过亲历者自述、心理影响分析与求助指引，还原言语攻击、人肉搜索与精神创伤造成的伤害后果，陪伴当事人走出阴影。"
      />
      <meta name="keywords" content="网暴黑料,网暴黑料受害者,网暴黑料当事人,网暴黑料伤害,网暴黑料心理" />
      <link rel="canonical" href="/" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content="回声墙｜网暴黑料亲历者档案 · 受害者亲述与心理伤害记录" />
      <meta
        property="og:description"
        content="记录网暴黑料亲历者的真实处境：言语攻击、人肉搜索与精神创伤如何摧毁普通人的生活。"
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="回声墙｜网暴黑料亲历者档案" />
      <script type="application/ld+json">{JSON.stringify(webSiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>

      <Hero />
      <StatsBand />
      <FeaturedStories />
      <HarmGrid />
      <RecoveryPath />
      <AboutPreview />
      <FaqSection />
      <HelpCta />
    </>
  );
}